import { memo, type JSX } from 'react';
import { styled } from '@mui/material';
import {
  CHART_LANE_MIN_ROW_HEIGHT,
  CHART_LANE_Y_AXIS_WIDTH,
} from '@/constants/PatientDashboard/patientTimeline';
import type { BiomarkerSelection, IBiomarkerLine } from '@/types/PatientDashboard/PatientTimeline.types';
import BiomarkerLegendRow from './BiomarkerLegendRow';
import { LaneLabelColumn } from './ChartLane.styles';

const Panel = styled(LaneLabelColumn)({
  height: `${CHART_LANE_MIN_ROW_HEIGHT}px`,
  overflowY: 'auto',
  gap: '2px',
  padding: `8px ${CHART_LANE_Y_AXIS_WIDTH}px 8px 0`,
});

interface IProps {
  lines: IBiomarkerLine[];
  selection: BiomarkerSelection;
  onToggle: (variantId: string) => void;
}

function BiomarkerLegend({ lines, selection, onToggle }: IProps): JSX.Element {
  return (
    <Panel>
      {lines.map((line) => (
        <BiomarkerLegendRow
          key={line.variantId}
          line={line}
          isSelected={Boolean(selection[line.variantId])}
          onToggle={onToggle}
        />
      ))}
    </Panel>
  );
}

export default memo(BiomarkerLegend);
